import QueryString from "qs";
import { useState } from "react";
import useSWR from "swr";
import swrFetcher from "@/utils/swrFetcher";

export default function usePartnerContactCheck({ locationName, phoneNumber, companyId, enabled }) {
  const [isDismissed, setIsDismissed] = useState(false);

  const params = QueryString.stringify({
    filters: {
      company: companyId,
      name: locationName,
    },
    pagination: { page: 1, pageSize: 1 },
  });

  const { data, isLoading } = useSWR(
    enabled && !isDismissed && locationName && companyId ? ["/partners", params] : null,
    swrFetcher,
  );

  const partnerData = data?.data?.[0]?.attributes;
  const dbPhoneNumber = partnerData?.managerPhoneNumber;
  const managerName = partnerData?.managerName;

  // DB 연락처를 화물 이력과 동일한 형식으로 만들기
  const dbContact = dbPhoneNumber ? `${dbPhoneNumber}${managerName ? `(${managerName})` : ""}` : "";

  // 연락처 정규화 함수: 전화번호 부분의 하이픈/공백 제거, 이름 부분은 유지
  const normalizeContact = (contact) => {
    if (!contact) return "";

    // "010-1234-5678(김철수)" 형태를 파싱
    const match = contact.match(/^(.+?)(\(.+\))?$/);
    if (!match) return contact.replace(/[\s-]/g, "");

    const phoneNumber = match[1].replace(/[\s-]/g, ""); // 전화번호 정규화
    const name = match[2] || ""; // 이름 부분은 그대로

    return `${phoneNumber}${name}`;
  };

  // 전화번호와 이름을 함께 비교
  const isMismatch =
    partnerData &&
    dbPhoneNumber &&
    phoneNumber &&
    normalizeContact(dbContact) !== normalizeContact(phoneNumber);

  return {
    isMismatch: isMismatch && !isDismissed, // dismiss 상태 반영
    isLoading,
    dbContact,
    dismiss: () => setIsDismissed(true),
  };
}
